import React from 'react';
import { Flex, Icon, Text, Wrapper } from '@qga/roo-ui/components';
import NonRefundable from './components/NonRefundable';
import FlexibleCancellation from './components/FlexibleCancellation';
import { CancellationWindow } from 'types/property';

type Props = {
  cancellationPolicy: { isNonrefundable: boolean; description: string; cancellationWindows: CancellationWindow[] };
  fontSize: string | string[];
  hideBeforeDate: boolean;
  hideWhenNonRefundable: boolean;
  handleOnClick?: () => void;
  display: string;
  isMobile?: boolean;
  luxuryInclusions?: boolean;
};

const CancellationRefundSummary = ({
  cancellationPolicy,
  hideBeforeDate = false,
  hideWhenNonRefundable = false,
  handleOnClick,
  luxuryInclusions = false,
  ...rest
}: Props) => {
  const isNonrefundable = cancellationPolicy?.isNonrefundable;
  const cancellationWindows = cancellationPolicy?.cancellationWindows;

  return (
    <Wrapper {...rest}>
      {isNonrefundable ? (
        <Flex alignItems={'center'} alignContent={'center'} data-testid="non-refundable">
          <Icon name="infoOutline" size={16} color="greys.steel" mr={1} />
          {luxuryInclusions ? (
            <Text fontSize="16px">Non-refundable</Text>
          ) : (
            <NonRefundable handleOnClick={handleOnClick} fontSize="16px" hideWhenNonRefundable={hideWhenNonRefundable} />
          )}
        </Flex>
      ) : (
        <FlexibleCancellation
          cancellationWindows={cancellationWindows}
          handleOnClick={handleOnClick}
          fontSize="16px"
          hideBeforeDate={hideBeforeDate}
          hideWhenNonRefundable={hideWhenNonRefundable}
          isSpaceBetween={true}
        />
      )}
    </Wrapper>
  );
};

export default CancellationRefundSummary;
